export interface RightbarState {
  activeTab: RightTab;
}

export enum RightTab {
  Variants,
  Personalization,
}
